import { render, staticRenderFns } from "./SubPageContainer.vue?vue&type=template&id=325b1563&"
import script from "./SubPageContainer.vue?vue&type=script&lang=js&"
export * from "./SubPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports